import React from 'react';
import { Link } from 'react-router-dom';
import TenantNavbar from "../../TenantLanding/Navbar/tenantNavbar";
import Footer from "../../Footer/Footer";
import './TenantLanding.css';

const TenantLanding = () => {
  return (
    <>
      <TenantNavbar />
      <div className="landing-page">
        {/* Hero Section */}
        <section className="hero-section">
          <div className="container">
            <div className="hero-content">
              <h1>Welcome to Our Platform</h1>
              <p>Empowering professionals through competency-based learning and development</p>
              <div className="hero-buttons">
                <Link to="/join-ecosystem" className="btn btn-primary">Join Ecosystem</Link>
                <Link to="/about" className="btn btn-outline-light">Learn More</Link>
              </div>
            </div>
          </div>
        </section>

        {/* Platform Section */}
        <section className="platform-section" id="platform">
          <div className="container">
            <h2>Our Platform</h2>
            <div className="row">
              <div className="col-md-4">
                <div className="feature-card">
                  <i className="fas fa-users"></i>
                  <h3>Mentorship</h3>
                  <p>Connect with experienced mentors in your field</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="feature-card">
                  <i className="fas fa-graduation-cap"></i>
                  <h3>Learning</h3>
                  <p>Access comprehensive learning modules</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="feature-card">
                  <i className="fas fa-certificate"></i>
                  <h3>Certifications</h3>
                  <p>Earn recognized certifications</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Competency Section */}
        <section className="competency-section" id="competency">
          <div className="container">
            <h2>Competency Framework</h2>
            <p>Build and track your competencies with our structured framework</p>
            <Link to="/competency" className="btn btn-light">Learn More</Link>
          </div>
        </section>

        {/* Industries Section */}
        <section className="industries-section" id="industries">
          <div className="container">
            <h2>Industries We Serve</h2>
            <div className="row">
              <div className="col-md-3">
                <div className="industry-item">Healthcare</div>
              </div>
              <div className="col-md-3">
                <div className="industry-item">Technology</div>
              </div>
              <div className="col-md-3">
                <div className="industry-item">Finance</div>
              </div>
              <div className="col-md-3">
                <div className="industry-item">Education</div>
              </div>
            </div>
            <div className="text-center mt-4">
              <Link to="/industries" className="btn btn-primary">View All Industries</Link>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="services-section" id="services">
          <div className="container">
            <h2>Our Services</h2>
            <div className="row">
              <div className="col-md-4">
                <div className="service-card">
                  <h4>Training Programs</h4>
                  <p>Comprehensive training programs tailored to your needs</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="service-card">
                  <h4>Assessment</h4>
                  <p>Skill assessment and progress tracking</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="service-card">
                  <h4>Career Development</h4>
                  <p>Career guidance and professional development</p>
                </div>
              </div>
            </div>
            <div className="text-center mt-4">
              <Link to="/services" className="btn btn-primary">View All Services</Link>
            </div>
          </div>
        </section>

        {/* About Section */}
        <section className="about-section" id="about">
          <div className="container">
            <h2>About Us</h2>
            <p>We are dedicated to transforming professional development through innovative learning solutions.</p>
            <Link to="/about" className="btn btn-light">Learn More</Link>
          </div>
        </section>

        {/* Join Ecosystem CTA */}
        <section className="cta-section">
          <div className="container">
            <h2>Ready to Join Our Ecosystem?</h2>
            <p>Start your journey towards professional excellence today</p>
            <Link to="/join-ecosystem" className="btn btn-primary btn-lg">Join Now</Link>
          </div>
        </section>
    </div>
      <Footer />
    </>
  );
};

export default TenantLanding;